import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { Track } from '../../school_panel/components/ui';
import { SETUP_STEPS, setupProgress, useSetupSummary } from './SetupChecklist';

// Dashboard strip while the school is not fully set up; it disappears once every step is done.
export default function SetupBanner() {
  const q = useSetupSummary();
  if (!q.data) return null;
  const done = setupProgress(q.data);
  if (done >= SETUP_STEPS.length) return null;
  const next = SETUP_STEPS.find((s) => !s.done(q.data!))!;
  return (
    <section aria-label="School setup" className="flex flex-wrap items-center gap-x-5 gap-y-3 rounded-[16px] border border-accent-line bg-accent-bg px-5 py-4">
      <div className="min-w-0 flex-[1_1_260px]">
        <p className="text-sm font-semibold text-warm-ink">Finish setting up your school</p>
        <p className="mt-0.5 text-[13px] text-warm-ink/80">Next: {next.title.toLowerCase()}.</p>
      </div>
      <div className="flex flex-[0_1_220px] items-center gap-2.5">
        <span className="font-mono text-xs font-semibold text-warm-ink">{done}/{SETUP_STEPS.length}</span>
        <div className="flex-1"><Track value={(done / SETUP_STEPS.length) * 100} tone="accent" label="Setup progress" /></div>
      </div>
      <Link to="/setup-guide" className="inline-flex min-h-[40px] items-center gap-1 rounded-[12px] bg-navy px-4 text-sm font-semibold text-white no-underline hover:text-white hover:brightness-110">
        Continue setup<ChevronRight size={16} aria-hidden />
      </Link>
    </section>
  );
}
